import { render, staticRenderFns } from "./VendorProjectsTable.vue?vue&type=template&id=1032a590&scoped=true&"
import script from "./VendorProjectsTable.vue?vue&type=script&lang=js&"
export * from "./VendorProjectsTable.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/dashboard/datatable.scss?vue&type=style&index=0&id=1032a590&scoped=true&lang=css&"
import style1 from "./VendorProjectsTable.vue?vue&type=style&index=1&id=1032a590&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1032a590",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1032a590')) {
      api.createRecord('1032a590', component.options)
    } else {
      api.reload('1032a590', component.options)
    }
    module.hot.accept("./VendorProjectsTable.vue?vue&type=template&id=1032a590&scoped=true&", function () {
      api.rerender('1032a590', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/projects/VendorProjectsTable.vue"
export default component.exports